import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faArrowUp,
    faBell,
    faBolt,
    faBurn,
    faCalculator,
    faChartArea,
    faChartBar,
    faCheckSquare,
    faClock,
    faCloud,
    faCodeBranch,
    faCog,
    faColumns,
    faCompress,
    faCopy,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faExchangeAlt,
    faExclamationTriangle,
    faExternalLinkAlt,
    faEye,
    faFile,
    faFileArchive,
    faFileExport,
    faFilter,
    faFolder,
    faHdd,
    faInfoCircle,
    faLaptop,
    faLink,
    faList,
    faLock,
    faMinusSquare,
    faPause,
    faPen,
    faPlay,
    faPlus,
    faPlusSquare,
    faQuestion,
    faShareAlt,
    faSitemap,
    faStream,
    faTags,
    faTools,
    faTrash,
    faTrashRestore,
    faUndo,
    faUserLock,
    faWrench,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
    faArrowUp,
    faBell,
    faBolt,
    faBurn,
    faCalculator,
    faChartArea,
    faChartBar,
    faCheckSquare,
    faClock,
    faCloud,
    faCodeBranch,
    faColumns,
    faCompress,
    faCopy,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faExchangeAlt,
    faExternalLinkAlt,
    faEye,
    faFileArchive,
    faFileExport,
    faFilter,
    faFile,
    faFolder,
    faCog,
    faHdd,
    faInfoCircle,
    faLaptop,
    faLink,
    faList,
    faLock,
    faMinusSquare,
    faPause,
    faPen,
    faPlay,
    faPlus,
    faPlusSquare,
    faQuestion,
    faShareAlt,
    faSitemap,
    faStream,
    faTags,
    faTools,
    faTrash,
    faTrashRestore,
    faExclamationTriangle,
    faUndo,
    faUserLock,
    faWrench
);

export const iconMixin = {
    components: {
        Icon: FontAwesomeIcon,
    },
};

export const iconPlugin = {
    install(Vue) {
        Vue.mixin(iconMixin);
    },
};
